import React from "react"
import styled from "styled-components"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { TOnClick } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import IconButton from "../../atoms/Buttons/IconButton"
import Overlay from "components/ProjectNonSpecificComponents/Elements/Overlay/Overlay"

interface Props {
	onClose?: TOnClick<HTMLButtonElement | HTMLElement>
	children?: React.ReactNode
}

const ModalWithTwoParts = ({ onClose = () => {}, children }: Props) => {
	const onOuterClickFn = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		e.preventDefault()
		if (e.currentTarget != e.target) return
		onClose(e)
	}

	return (
		<div className="blur-bg-overlay" onClick={onOuterClickFn}>
			<Overlay screenCentered entranceFliesUpAnimated>
				<ModalBase className="flex-col">
					<IconButton
						iconKey="cross"
						iconWidth={15}
						iconHeight={15}
						iconColor="#C2C2C2"
						onClick={onClose}
						style={{ cursor: "pointer", position: "absolute" }}
						className="right-6 top-5"
					/>
					<HyperDiv direction="column" style={{ overflow: "hidden" }}>
						<div style={{ overflowY: "scroll", overflowX: "hidden" }}>{children}</div>
					</HyperDiv>
				</ModalBase>
			</Overlay>
		</div>
	)
}

export default ModalWithTwoParts

const ModalBase = styled.div`
	min-width: 320px;
	max-width: 100vw;
	max-height: 90vh;
	border-radius: 10px;
	background-color: var(--white);
	overflow: hidden;
`
